import "./App.css";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./component/access/ProtectedRoute";
import ScrollToTop from "./component/ScrollToTop";
import PaymentSuccess from "./pages/PaymentSuccess";

import Home            from "./pages/Home";
import Price           from "./pages/Price";
import Register        from "./pages/Register";
import Login           from "./pages/Login";
import Gallary         from "./pages/Gallary";
import GalleryCategory from "./pages/GalleryCategory";
import GalleryDetail   from "./pages/GalleryDetail";
import GalleryGroupImages from "./pages/GalleryGroupImages";
import ThankYou        from "./pages/Thankyou";
import About           from "./pages/AboutUs";
import Guest           from "./pages/Guestchallenging";
import Education       from "./pages/Education";
import RefineResourceDetail from "./pages/RefineResourceDetail";
import PrivacyPolicy   from "./pages/PrivacyPolicy";
import Terms           from "./pages/TermsConditions";
import ResetPassword   from "./pages/ResetPassword";
import ContentDetail   from "./pages/ContentDetail";
import Contact         from "./pages/Contact";
import Shop            from "./pages/Shop";
import Community       from "./pages/Community";
import Donation        from "./pages/Donation";
import Product_Details from "./pages/Product_Details";
import Projects        from "./pages/Projects";
import Submission      from "./pages/Submission";
import Quiz            from "./pages/Quiz";
import AttemptQuiz     from "./component/AttemptQuiz";
import Profile         from "./pages/Profile";
import Blogs           from "./pages/Blogs";
import ThemeBlogs      from "./pages/ThemeBlogs";
import Challengedetails from "./component/Challengedetails";
import Awards          from "./pages/Awards";
import Badges          from "./pages/Badges";
import Notifications   from "./pages/Notifications";
import ReviewerDashboard from "./pages/ReviewerDashboard";
import MentorDashboard from "./pages/MentorDashboard";
import MentorMessages from "./pages/MentorMessages";
import Discussions from "./pages/Discussions";
import DiscussionDetail from "./pages/DiscussionDetail";

import "@fancyapps/ui/dist/fancybox/fancybox.css";

function App() {
  return (
    <>
    <ScrollToTop />
    <Routes>

      {/* ── PUBLIC ──────────────────────────────────────────── */}
      <Route path="/"                       element={<Home />} />
      <Route path="/about"                  element={<About />} />
      <Route path="/gallary"                element={<Gallary />} />
      <Route path="/gallery"                element={<Gallary />} />
      <Route path="/gallery/:category"      element={<GalleryCategory />} />
      <Route path="/gallery/:gallerySlug/:galleryId" element={<GalleryDetail />} />
      <Route path="/gallery/:gallerySlug/:galleryId/:groupId" element={<GalleryGroupImages />} />
      <Route path="/membership"             element={<Price />} />
      <Route path="/privacyPolicy"          element={<PrivacyPolicy />} />
      <Route path="/terms"                  element={<Terms />} />
      <Route path="/login"                  element={<Login />} />
      <Route path="/register"               element={<Register />} />
      <Route path="/thankyou"               element={<ThankYou />} />
      <Route path="/reset-password/:token"  element={<ResetPassword />} />
      <Route path="/contact"                element={<Contact />} />

      {/* ── FREE+ (login required, free tier allowed) ───────── */}
      <Route path="/profile/:id" element={<ProtectedRoute requireAuth><Profile /></ProtectedRoute>} />
      <Route path="/profile"     element={<ProtectedRoute requireAuth><Profile /></ProtectedRoute>} />
      <Route path="/dashboard"   element={<ProtectedRoute requireAuth><Profile /></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute requireAuth><Notifications /></ProtectedRoute>} />
      <Route path="/reviewer" element={<ProtectedRoute requireAuth requireRole="reviewer"><ReviewerDashboard /></ProtectedRoute>} />
      <Route path="/mentor" element={<ProtectedRoute requireAuth requireRole="mentor"><MentorDashboard /></ProtectedRoute>} />
      <Route path="/mentor-messages" element={<ProtectedRoute requireAuth><MentorMessages /></ProtectedRoute>} />
      <Route path="/donation"    element={<ProtectedRoute requireAuth><Donation /></ProtectedRoute>} />
      <Route path="/blogs"       element={<Blogs />} />
      <Route path="/blogs/theme/:themeSlug" element={<ThemeBlogs />} />
      <Route path="/blog/:slug" element={<ContentDetail />} />
      <Route path="/refine"      element={<ProtectedRoute requireAuth minTier="wanderer"><Education /></ProtectedRoute>} />
      <Route path="/refine/:slug" element={<ProtectedRoute requireAuth minTier="wanderer"><RefineResourceDetail /></ProtectedRoute>} />

      {/* Quest listing and schedule */}
      <Route path="/quests"          element={<Guest />} />
      <Route path="/whats-happening" element={<Guest />} />
      <Route path="/guest"           element={<Guest />} />
      <Route path="/quests/:id"      element={<Challengedetails />} />
      <Route path="/:id/qusts"       element={<Challengedetails />} />

      {/* Free: submissions page — 1 entry limit enforced in-page */}
      <Route path="/submissions" element={<ProtectedRoute requireAuth><Submission /></ProtectedRoute>} />

      {/* Free: self-evaluation quiz — full quiz attempts require wanderer+ (enforced in-page) */}
      <Route path="/quiz"        element={<ProtectedRoute requireAuth><Quiz /></ProtectedRoute>} />

      {/* ── WANDERER+ ───────────────────────────────────────── */}
      <Route path="/shop"        element={<ProtectedRoute requireAuth minTier="wanderer"><Shop /></ProtectedRoute>} />
      <Route path="/detail/:id"  element={<ProtectedRoute requireAuth minTier="wanderer"><Product_Details /></ProtectedRoute>} />
      <Route path="/education"   element={<ProtectedRoute requireAuth minTier="wanderer"><Education /></ProtectedRoute>} />
      <Route path="/community"   element={<ProtectedRoute requireAuth minTier="wanderer"><Community /></ProtectedRoute>} />
      <Route path="/discussions" element={<ProtectedRoute requireAuth minTier="wanderer"><Discussions /></ProtectedRoute>} />
      <Route path="/discussions/:id" element={<ProtectedRoute requireAuth minTier="wanderer"><DiscussionDetail /></ProtectedRoute>} />
      <Route path="/awards"      element={<ProtectedRoute requireAuth minTier="wanderer"><Awards /></ProtectedRoute>} />
      <Route path="/badges"      element={<ProtectedRoute requireAuth minTier="wanderer"><Badges /></ProtectedRoute>} />
      <Route path="/attemp-quiz/:id" element={<ProtectedRoute requireAuth minTier="wanderer"><AttemptQuiz /></ProtectedRoute>} />

      {/* ── KINDRED+ ────────────────────────────────────────── */}
      <Route path="/projects"    element={<ProtectedRoute requireAuth minTier="kindred"><Projects /></ProtectedRoute>} />

      {/* ── DYNAMIC CONTENT ─────────────────────────────────── */}
      <Route path="/:type/:slug" element={<ContentDetail />} />

      {/* ── PAYMENT SUCCESS ─────────────────────────────────── */}
      <Route path="/payment-success" element={<PaymentSuccess />} />

    </Routes>
    </>
  );
}

export default App;
